"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileGeneral = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const notistack_1 = require("notistack");
const react_intl_1 = require("react-intl");
const constants_1 = require("@framework/constants");
const constants_2 = require("@dzambalaorg/constants");
const mui_form_1 = require("@dzambalaorg/mui-form");
const mui_inputs_image_firebase_1 = require("@dzambalaorg/mui-inputs-image-firebase");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const provider_user_1 = require("@dzambalaorg/provider-user");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const store_1 = require("@dzambalaorg/store");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const validation_1 = require("./validation");
const ProfileGeneral = (props) => {
    const { open } = props;
    const user = (0, provider_user_1.useUser)();
    const { enqueueSnackbar } = (0, notistack_1.useSnackbar)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const changeLanguage = (0, store_1.useGlobalStore)(state => state.changeLanguage);
    const { mutateAsync } = (0, react_hooks_1.useMutationQuery)({
        onConfirm: async ({ data }) => {
            await user.setProfile(data).then(() => {
                if (user.profile.language !== data.language) {
                    changeLanguage(data.language);
                }
            });
        },
    });
    if (!open) {
        return null;
    }
    const onClick = () => {
        enqueueSnackbar(formatMessage({ id: "form.hints.emailWarning" }), { variant: "info" });
    };
    const handleSubmit = async ({ data, form }) => {
        await mutateAsync({ data, form });
    };
    const { email, displayName, language, gender, country, imageUrl } = user.profile;
    const fixedValues = {
        email,
        displayName,
        gender: gender ?? "",
        country: country ?? "",
        language,
        imageUrl,
    };
    return ((0, jsx_runtime_1.jsx)(mui_form_1.FormWrapper, { initialValues: fixedValues, validationSchema: validation_1.profileGeneralValidationSchema, onSubmit: handleSubmit, children: (0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2, 3, 3], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "email", autoComplete: "off", onClick: onClick }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "displayName" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "gender", options: constants_2.EnabledGenders }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "country", options: constants_2.EnabledCountries }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "language", options: constants_1.EnabledLanguages }), (0, jsx_runtime_1.jsx)(mui_inputs_image_firebase_1.AvatarInput, { name: "imageUrl" }), (0, jsx_runtime_1.jsx)(ui_kit_1.FormGrid.Empty, {}), (0, jsx_runtime_1.jsx)(ui_kit_1.FormGrid.Empty, {})] }) }));
};
exports.ProfileGeneral = ProfileGeneral;
//# sourceMappingURL=index.js.map